// import React, { useState } from 'react';

// /* ─── Styles ─────────────────────────────────────────────── */
// const S = {
//   card: {
//     background: '#fff',
//     borderRadius: 14,
//     boxShadow: '0 1px 3px rgba(0,0,0,.07), 0 4px 16px rgba(0,0,0,.05)',
//     padding: '28px 28px',
//     marginBottom: 28,
//   },
//   cardTitle: {
//     margin: '0 0 20px',
//     fontSize: 13,
//     fontWeight: 600,
//     textTransform: 'uppercase',
//     letterSpacing: '0.08em',
//     color: '#8892a4',
//   },
//   fieldGroup: {
//     display: 'flex',
//     flexDirection: 'column',
//     gap: 6,
//   },
//   label: {
//     fontSize: 12,
//     fontWeight: 600,
//     color: '#4a5568',
//     letterSpacing: '0.04em',
//   },
//   input: (focused) => ({
//     padding: '10px 14px',
//     border: `1.5px solid ${focused ? '#4361ee' : '#e2e8f0'}`,
//     borderRadius: 8,
//     fontSize: 14,
//     color: '#1a2340',
//     outline: 'none',
//     background: focused ? '#f8f9ff' : '#fafafa',
//     transition: 'border-color .2s, background .2s, box-shadow .2s',
//     boxShadow: focused ? '0 0 0 3px rgba(67,97,238,.12)' : 'none',
//     width: '100%',
//     boxSizing: 'border-box',
//     fontFamily: 'inherit',
//   }),
//   btnPrimary: (loading) => ({
//     padding: '10px 22px',
//     background: 'linear-gradient(135deg, #4361ee, #3a86ff)',
//     color: '#fff',
//     border: 'none',
//     borderRadius: 8,
//     fontSize: 14,
//     fontWeight: 600,
//     cursor: loading ? 'not-allowed' : 'pointer',
//     display: 'inline-flex',
//     alignItems: 'center',
//     gap: 7,
//     boxShadow: '0 2px 8px rgba(67,97,238,.30)',
//     transition: 'opacity .15s, transform .15s',
//     letterSpacing: '0.02em',
//     opacity: loading ? 0.7 : 1,
//   }),
// };

// /* ─── Sub-components ─────────────────────────────────────── */
// const Field = ({ label, value, onChange, placeholder }) => {
//   const [focused, setFocused] = useState(false);
//   return (
//     <div style={S.fieldGroup}>
//       <label style={S.label}>{label}</label>
//       <input
//         placeholder={placeholder}
//         value={value}
//         onChange={onChange}
//         onFocus={() => setFocused(true)}
//         onBlur={() => setFocused(false)}
//         style={S.input(focused)}
//       />
//     </div>
//   );
// };

// const SelectField = ({ label, value, onChange, options }) => {
//   const [focused, setFocused] = useState(false);
//   return (
//     <div style={S.fieldGroup}>
//       <label style={S.label}>{label}</label>
//       <select
//         value={value}
//         onChange={onChange}
//         onFocus={() => setFocused(true)}
//         onBlur={() => setFocused(false)}
//         style={{ ...S.input(focused), cursor: 'pointer', appearance: 'auto' }}
//       >
//         {options.map((opt) => (
//           <option key={opt.value} value={opt.value}>{opt.label}</option>
//         ))}
//       </select>
//     </div>
//   );
// };

// const DateField = ({ label, value, onChange }) => {
//   const [focused, setFocused] = useState(false);
//   return (
//     <div style={S.fieldGroup}>
//       <label style={S.label}>{label}</label>
//       <input
//         type="date"
//         value={value}
//         onChange={onChange}
//         onFocus={() => setFocused(true)}
//         onBlur={() => setFocused(false)}
//         style={S.input(focused)}
//       />
//     </div>
//   );
// };

// /* ─── ProjectForm ────────────────────────────────────────── */
// const ProjectForm = ({
//   name, setName,
//   description, setDescription,
//   status, setStatus,
//   startDate, setStartDate,
//   endDate, setEndDate,
//   handleCreate,
//   loading,
// }) => {
//   return (
//     <div style={S.card}>
//       <p style={S.cardTitle}>New Project</p>

//       {/* Row 1 — Name + Description */}
//       <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '14px 20px', marginBottom: 14 }}>
//         <Field
//           label="Project Name *"
//           value={name}
//           onChange={(e) => setName(e.target.value)}
//           placeholder="e.g. Employee Portal"
//         />
//         <Field
//           label="Description"
//           value={description}
//           onChange={(e) => setDescription(e.target.value)}
//           placeholder="Brief description of the project…"
//         />
//       </div>

//       {/* Row 2 — Status + Start Date + End Date */}
//       <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '14px 20px', marginBottom: 20 }}>
//         <SelectField
//           label="Status"
//           value={status}
//           onChange={(e) => setStatus(e.target.value)}
//           options={[
//             { value: 'ACTIVE',    label: '🟢 Active' },
//             { value: 'COMPLETED', label: '✅ Completed' },
//             { value: 'ON_HOLD',   label: '🟡 On Hold' },
//           ]}
//         />
//         <DateField
//           label="Start Date"
//           value={startDate}
//           onChange={(e) => setStartDate(e.target.value)}
//         />
//         <DateField
//           label="End Date"
//           value={endDate}
//           onChange={(e) => setEndDate(e.target.value)}
//         />
//       </div>

//       <button
//         style={S.btnPrimary(loading)}
//         onClick={handleCreate}
//         disabled={loading}
//       >
//         {loading ? '⏳ Creating…' : '＋ Create Project'}
//       </button>
//     </div>
//   );
// };

// export default ProjectForm;



import React, { useState } from 'react';

/* ─── Styles ─────────────────────────────────────────────── */
const S = {
  overlay: {
    position: 'fixed',
    inset: 0,
    background: 'rgba(15,23,42,0.45)',
    backdropFilter: 'blur(3px)',
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    animation: 'fadeIn .2s ease',
  },
  modal: {
    background: '#fff',
    borderRadius: 16,
    boxShadow: '0 20px 60px rgba(0,0,0,.2)',
    padding: '32px 32px 28px',
    width: '100%',
    maxWidth: 560,
    animation: 'slideUp .25s ease',
    boxSizing: 'border-box',
  },
  modalHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 24,
  },
  modalTitle: {
    margin: 0,
    fontSize: 18,
    fontWeight: 700,
    color: '#1a2340',
    letterSpacing: '-0.3px',
  },
  closeBtn: {
    background: '#f1f5f9',
    border: 'none',
    borderRadius: 8,
    width: 32,
    height: 32,
    fontSize: 16,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#64748b',
    transition: 'background .15s',
  },
  divider: {
    border: 'none',
    borderTop: '1px solid #f0f3fa',
    margin: '0 0 22px',
  },
  grid2: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '14px 20px',
    marginBottom: 14,
  },
  grid3: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr 1fr',
    gap: '14px 20px',
    marginBottom: 24,
  },
  fieldGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: 6,
  },
  label: {
    fontSize: 12,
    fontWeight: 600,
    color: '#4a5568',
    letterSpacing: '0.04em',
  },
  input: (focused) => ({
    padding: '10px 14px',
    border: `1.5px solid ${focused ? '#4361ee' : '#e2e8f0'}`,
    borderRadius: 8,
    fontSize: 14,
    color: '#1a2340',
    outline: 'none',
    background: focused ? '#f8f9ff' : '#fafafa',
    transition: 'border-color .2s, background .2s, box-shadow .2s',
    boxShadow: focused ? '0 0 0 3px rgba(67,97,238,.12)' : 'none',
    width: '100%',
    boxSizing: 'border-box',
    fontFamily: 'inherit',
  }),
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 10,
  },
  btnCancel: {
    padding: '10px 20px',
    background: '#f1f5f9',
    color: '#64748b',
    border: 'none',
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 600,
    cursor: 'pointer',
  },
  btnCreate: (loading) => ({
    padding: '10px 22px',
    background: 'linear-gradient(135deg, #4361ee, #3a86ff)',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    fontSize: 14,
    fontWeight: 600,
    cursor: loading ? 'not-allowed' : 'pointer',
    opacity: loading ? 0.7 : 1,
    display: 'inline-flex',
    alignItems: 'center',
    gap: 7,
    boxShadow: '0 2px 8px rgba(67,97,238,.30)',
    transition: 'opacity .15s',
  }),
};

/* ─── Field Helpers ──────────────────────────────────────── */
const Field = ({ label, value, onChange, placeholder, type }) => {
  const [focused, setFocused] = useState(false);
  return (
    <div style={S.fieldGroup}>
      <label style={S.label}>{label}</label>
      {/* <input
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={S.input(focused)}
      /> */}
      {type === "textarea" ? (
        <textarea
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          rows={4}
          style={{
            ...S.input(focused),
            minHeight: "100px",
            resize: "vertical"
          }}
        />
      ) : (
        <input
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          style={S.input(focused)}
        />
      )}
    </div>
  );
};

const SelectField = ({ label, value, onChange }) => {
  const [focused, setFocused] = useState(false);
  return (
    <div style={S.fieldGroup}>
      <label style={S.label}>{label}</label>
      <select
        value={value}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={{ ...S.input(focused), cursor: 'pointer', appearance: 'auto' }}
      >
        <option value="ACTIVE">🟢 Active</option>
        <option value="COMPLETED">✅ Completed</option>
        <option value="ON_HOLD">🟡 On Hold</option>
      </select>
    </div>
  );
};

const DateField = ({ label, value, onChange }) => {
  const [focused, setFocused] = useState(false);
  return (
    <div style={S.fieldGroup}>
      <label style={S.label}>{label}</label>
      <input
        type="date"
        value={value}
        onChange={onChange}
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        style={S.input(focused)}
      />
    </div>
  );
};

/* ─── CreateProjectModal ─────────────────────────────────── */
const CreateProjectModal = ({ onClose, onCreate }) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [status, setStatus] = useState('ACTIVE');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [loading, setLoading] = useState(false);

  const resetForm = () => {
    setName('');
    setDescription('');
    setStatus('ACTIVE');
    setStartDate('');
    setEndDate('');
  };

  const handleCreate = async () => {
    if (!name.trim()) return;

    if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
      alert('Start Date cannot be greater than End Date');
      return;
    };
    setLoading(true);
    await onCreate({
      name: name.trim(),
      description: description.trim(),
      status,
      startDate: startDate || null,
      endDate: endDate || null,
    });
    setLoading(false);
    resetForm();
    onClose();
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div style={S.overlay} onClick={handleOverlayClick}>
      <style>{`
        @keyframes fadeIn  { from { opacity:0 } to { opacity:1 } }
        @keyframes slideUp { from { opacity:0; transform:translateY(18px) } to { opacity:1; transform:translateY(0) } }
      `}</style>

      <div style={S.modal}>
        {/* Header */}
        <div style={S.modalHeader}>
          <h2 style={S.modalTitle}>📁 New Project</h2>
          <button style={S.closeBtn} onClick={onClose}>✕</button>
        </div>
        <hr style={S.divider} />

        {/* Row 1 — Name + Description */}
        <div style={S.grid2}>
          <Field
            label="Project Name *"
            value={name}
            onChange={(e) => setName(e.target.value)}
            placeholder="e.g. Employee Portal"
          />
          {/* <Field
            label="Description"
            type="textarea"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Brief description…"
          /> */}
        </div>

        {/* Row 2 — Status + Start Date + End Date */}
        <div style={S.grid3}>
          <SelectField
            label="Status"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          />
          <DateField
            label="Start Date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
          <DateField
            label="End Date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </div>
        <div style={{ marginBottom: 20 }}>
          <Field
            label="Description"
            type="textarea"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            placeholder="Brief description…"
          />
        </div>

        {/* Footer */}
        <div style={S.footer}>
          <button style={S.btnCancel} onClick={onClose}>Cancel</button>
          <button style={S.btnCreate(loading)} onClick={handleCreate} disabled={loading}>
            {loading ? '⏳ Creating…' : '＋ Create Project'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreateProjectModal;